export const FETCH_WORKERS = "Workers.FETCH_WORKERS";
export const FETCH_WORKERS_SUCCESS = "Workers.FETCH_WORKERS_SUCCESS";
export const FETCH_WORKERS_FAILURE = "Workers.FETCH_WORKERS_FAILURE";

export const FETCH_WORKER_POSITIONS = "Workers.FETCH_WORKER_POSITIONS";
export const FETCH_WORKER_POSITIONS_SUCCESS = "Workers.FETCH_WORKER_POSITIONS_SUCCESS";
export const FETCH_WORKER_POSITIONS_FAILURE = "Workers.FETCH_WORKER_POSITIONS_FAILURE";
